import { Type } from "class-transformer";
import { AddressModel } from "./address";
import { OrderState } from './order-state';
import { OrderIdsModel } from "./orderIds-model";
import { SalesDistrictType } from "./sales-district";
import { CustomerStatusEnum } from "@app/customer-selector/customer-selector.component";

export class CustomerModel {

	constructor(
		public No: string,
		public Type: CustomerType,
		public SalesDistrictType: SalesDistrictType,
		public Name: string,
		public Street: string,
		public ShipToName: string,
		public IsPlusPartner: boolean,
		public IsPreciousPartner: boolean,
		public IsBlocked: boolean,
		public Email: string,
		public EmailAddresses: Array<string>,
		public ShipToAddresses: Array<AddressModel>,
		public ProductLinesPermissions: Array<string>,
		public Assortments: Array<string>,
		public Token: string | undefined,
		public StartkitsOnActiveOrders: Array<string | null | undefined>,
		public OrderIds: Array<OrderIdsModel>,
		public Address: string | undefined,
		public IsNewPartner: boolean,
		public IsOrderDeeplinkMode: boolean,
		public ShowBrands: boolean,
		public KeringEyewearBrands?: string,
		public Code?: string,
		public CountryCode?: string,

		public Status?: CustomerStatusEnum
	) {
	}

	public get AddressStringified() {
		return this.Address ? ', ' + this.Address.replace(/\r/g, ', ') : '';
	}

	public get AddressStringified2() {
		return this.Address ? this.Address.replace(/\r/g, ', ') : '';
	}

	public get isConsultantOrderOnBehalf() {
		return this.Type === CustomerType.OrderOnBehalf;
	}

	hasProductLineAccess(productLineCode?: string): boolean {
		return this.ProductLinesPermissions?.some(x => x === productLineCode);
	}

}

export class CustomerOrderRelevantModel {

	constructor(orders: OrderState[] | null) {
		if (orders) {
			this.StartkitsOnActiveOrders = orders.selectMany(o => o.OrderItems).map(oi => oi.ProductLineCode);
			this.OrderIds = orders.map(o => new OrderIdsModel(o));
		}
	}

	public StartkitsOnActiveOrders: Array<string | null | undefined> = []

	@Type(() => OrderIdsModel)
	public OrderIds: Array<OrderIdsModel> = []

}

export enum CustomerType {
	OrderOnBehalf,
	ChainCustomer
}
